import React from 'react';
import SearchBox from './SearchBox';
import './HomeHero.css';

// Hero: big headline + oversized pill search over a soft ghosted background.
const HomeHero = () => (
    <section className="gh-hero">
        <h1 className="gh-hero-title">Shop Pokémon</h1>
        <p className="gh-hero-sub">Every card PSA-graded.</p>

        <div className="gh-hero-search">
            <SearchBox
                variant="hero"
                source="home_hero"
                placeholder="Search by card name"
                iconSize={22}
            />
        </div>
    </section>
);

export default HomeHero;
